import React, { useEffect, useState } from "react";
// import { ShoppingCart } from "lucide-react";
import { supabase } from "../../lib/supabaseClient";
import { getPrimaryProductImageUrl } from "../../utils/imageUtils";
// import { useAuth } from "../../hooks/useAuth";
// import { useNavigate } from "react-router-dom";
// import { addProductToCart } from "../../hooks/useSupabase";
import { ProductGrid } from "../_ResponsiveComponents";

import type { Product } from "../../hooks/products";

// interface RecommendedProduct {
//   id: number;
//   name?: string;
//   description?: string;
//   usd_price?: number;
//   sale_rate?: number;
//   quantity?: number;
//   is_featured?: boolean;
//   image?: string;
// }

interface RecommendedProductsProps {
  products: Product[];
  loading?: boolean;
  title?: string;
}

const RecommendedProducts: React.FC<RecommendedProductsProps> = ({
  products,
  loading = false,
  title = "Recommended Products",
}) => {
  const [enhancedProducts, setEnhancedProducts] = useState<Product[]>([]);
  const [enhancedLoading, setEnhancedLoading] = useState(true);
  // const { user } = useAuth();
  // const navigate = useNavigate();
  // const [adding, setAdding] = useState<{ [id: number]: boolean }>({});

  useEffect(() => {
    if (!products || products.length === 0) {
      setEnhancedProducts([]);
      setEnhancedLoading(false);
      return;
    }
    const fetchEnhancedProducts = async () => {
      setEnhancedLoading(true);
      const enhancedPromises = products.map(async (item: any) => {
        try {
          const { data: detailedProduct, error: fetchError } =
            await supabase.rpc("fetch_product_with_images_by_id", {
              p_product_id: item.id,
              p_locale: "en",
            });
          if (fetchError) {
            // If fetch fails, return original item
            return item;
          }
          // The RPC returns specific fields, we need to map them back to Product structure if needed.
          // However, assuming detailedProduct structure is close enough or we just need the image.
          // For now, let's just attach the image if found.

          return {
            ...item,
            image: getPrimaryProductImageUrl(
              detailedProduct?.image_paths || [],
            ),
            // detailedProduct might have other fields, but we prioritize 'item' (original product)
            // and just want to enhance the image if missing?
            // Actually, the original code was mapping 'usd_price' to 'price'.
            // Since we are using standard Product, it already has 'price'.
          };
        } catch (err) {
          return item;
        }
      });
      const enhanced = await Promise.all(enhancedPromises);
      setEnhancedProducts(enhanced);
      setEnhancedLoading(false);
    };
    fetchEnhancedProducts();
  }, [products]);

  if (loading || enhancedLoading) {
    return (
      <div className="bg-neutral-900 rounded-lg shadow-sm p-6 mt-6 border border-neutral-800">
        <h3 className="text-lg font-semibold mb-4 text-white">{title}</h3>
        <div className="flex justify-center items-center py-8">
          <div className="text-sm text-neutral-400">
            Loading recommendations...
          </div>
        </div>
      </div>
    );
  }

  if (!enhancedProducts || enhancedProducts.length === 0) {
    return null;
  }

  return (
    <div className="bg-neutral-900 rounded-lg shadow-sm p-6 mt-6 h-auto ">
      <h3 className="text-lg font-semibold mb-4 text-white">{title}</h3>

      <ProductGrid
        products={enhancedProducts.slice(0, 4)}
        viewMode="grid"
        loading={enhancedLoading}
        is_HScroll={true}
      />
    </div>
  );
};

export default RecommendedProducts;
